
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"fxa-settings-header-wrapper\">\n  <header id=\"fxa-settings-header\">\n    <h1 id=\"fxa-manage-account\">{{#t}}Firefox Accounts{{/t}}</h1>\n    {{#showSignOut}}\n      <button id=\"signout\" class=\"settings-button secondary\">{{#t}}Sign out{{/t}}</button>\n    {{/showSignOut}}\n  </header>\n\n  <div class=\"settings-success-wrapper\">\n    <div class=\"success settings-success\"></div>\n  </div>\n</div>\n\n<div class=\"avatar-wrapper avatar-settings-view\"></div>\n<div id=\"fxa-settings-content\" class=\"card\">\n  <header id=\"fxa-settings-profile-header\">\n    {{{ unsafeHeaderHTML }}}\n  </header>\n  <div id=\"sub-panels\"></div>\n</div>\n\n<footer id=\"legal-footer\"><a class=\"terms\" href=\"/legal/terms\">{{#t}}Terms of Service{{/t}}</a><a class=\"privacy\" href=\"/legal/privacy\">{{#t}}Privacy Notice{{/t}}</a></footer>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/settings.mustache
// module id = 282
// module chunks = app